// Development requests go through the dev server on the machine serving the page.
// An explicit environment setting (including production) keeps its configured backend.
export function resolveApiBaseUrl(configuredUrl, pageUrl) {
  return configuredUrl || new URL('/api', pageUrl).href
}
